import styled from 'styled-components'

const Div = styled.div`
  background-color: #1e2123;
  box-sizing: border-box;
  color: #fff;
  display: ${({ active }) => (active ? 'block' : 'none')};
  margin: 0;
  overflow: auto;
  -webkit-text-size-adjust: 100%;
  padding: 2em 28px;
  &.packet_process_diagram {
    margin: 25px;
    background-image: url('https://developer.skypostal.com/images/packet_process_diagram.png');
    background-color: #F3F7F9!important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width:100%;
    height:1174px;
    display:block;
  };
  &.process_diagram {
    margin: 25px;
    background-image: url('https://developer.skypostal.com/images/process_diagram.png');
    background-color: #F3F7F9!important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width:100%;
    height:1800px;
    display:block;
  }

`
export default Div
